import { z } from 'zod';
/**
 * Mẫu tài liệu của tổ chức — APM-CD2-k, docs/plan-chilldoc-v2.md §9.1.
 *
 * Quản trị tổ chức đánh dấu một `.chilldoc` thành mẫu; mọi nhân sự của tổ chức thấy nó ở
 * "Tài liệu mới → Từ mẫu…" (APM-CD2-l). Server không đọc nội dung (luật #3): mẫu là một
 * **bản chép** của tệp gốc trên S3 (CopyObject), người dùng tải bằng presigned GET.
 */
/** Nhóm mẫu — chuỗi ở DB (không ENUM): thêm nhóm sau này không cần ALTER. */
export const DOCUMENT_TEMPLATE_CATEGORIES = [
    'meeting',
    'plan',
    'proposal',
    'spec',
    'report',
    'other',
];
export const DocumentTemplateCategory = z.enum(DOCUMENT_TEMPLATE_CATEGORIES);
export const DOCUMENT_TEMPLATE_NAME_MAX = 120;
export const DOCUMENT_TEMPLATE_DESCRIPTION_MAX = 500;
// `.trim()` đứng TRƯỚC `.min()` — bẫy Zod ở CLAUDE.md.
const TemplateName = z.string().trim().min(1).max(DOCUMENT_TEMPLATE_NAME_MAX);
/** Chuỗi rỗng sau khi cắt ⇒ `null` ("không mô tả"), không lưu `''`. */
const TemplateDescription = z
    .string()
    .trim()
    .max(DOCUMENT_TEMPLATE_DESCRIPTION_MAX)
    .transform((value) => (value.length ? value : null))
    .nullable();
/**
 * `POST templates` — `fileId` là tệp `.chilldoc` của người gọi ở trang Tệp, hoặc tệp của một
 * phiên bản tài liệu dự án mà họ đọc được.
 */
export const CreateDocumentTemplateInput = z.object({
    fileId: z.uuid(),
    name: TemplateName,
    description: TemplateDescription.optional(),
    category: DocumentTemplateCategory,
});
/** `PATCH templates/:id` — ít nhất một trường. Nội dung mẫu không sửa ở đây: muốn đổi thì tạo mẫu mới. */
export const UpdateDocumentTemplateInput = z
    .object({
    name: TemplateName.optional(),
    description: TemplateDescription.optional(),
    category: DocumentTemplateCategory.optional(),
})
    .refine((input) => input.name !== undefined || input.description !== undefined || input.category !== undefined, { message: 'Cần ít nhất một trường để sửa.' });
export const DocumentTemplateItem = z.object({
    id: z.uuid(),
    name: z.string(),
    description: z.string().nullable(),
    category: DocumentTemplateCategory,
    sizeBytes: z.number().int().nonnegative(),
    createdById: z.uuid(),
    createdByName: z.string(),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
    /**
     * Presigned GET của nội dung `.chilldoc`. `null` khi nội dung không còn đọc được (mẫu không chép
     * được sang khu của tổ chức và tệp gốc đã bị xoá) — giao diện hiện mẫu ở trạng thái hỏng.
     */
    contentUrl: z.string().nullable(),
});
export const DocumentTemplateList = z.object({
    items: z.array(DocumentTemplateItem),
    /** Người gọi có `document_template:manage` — hiện nút đổi tên / gỡ. */
    canManage: z.boolean(),
});
//# sourceMappingURL=document-template.js.map